import Enums from '../Enum'
import i18n from '@/i18n'
export default new Enums({
  ALL: {
    text: i18n._('全部'),
    value: 0,
  },
  ON_SALE: {
    text: i18n._('上架'),
    value: 1,
  },
  OFF_SALE: {
    text: i18n._('下架'),
    value: 2,
  },
})
